//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'm-process',
  computed: {
    partnerPhone () {
      if (this.$store.state.config.partnerPhone) {
        return this.$store.state.config.partnerPhone
      }
    },
    telPartnerPhone () {
      return 'tel:' + this.partnerPhone
    },
    lipeiliucheng () {
      if (this.$store.state.config.lipeiliucheng) {
        return this.$store.state.config.lipeiliucheng
      }
      return {}
    },
    process () {
      if (this.$store.state.config.process) {
        return this.$store.state.config.process
      }
    }
  },
  methods: {
    openNewWindow (url) {
      window.open(url)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Process.vue